import qs from 'qs';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as userActions from 'store/actions/user';

import { ROLES } from 'constants/roles';
import { ROUTE } from 'constants/routing';

export default TargetComponent => {
  const mapStateToProps = state => ({
    user: state.user
  });

  const mapDispatchToProps = dispatch => ({
    signIn: bindActionCreators(userActions.signIn, dispatch),
    logOut: bindActionCreators(userActions.logOut, dispatch),
    changeMenu: bindActionCreators(userActions.changeMenu, dispatch),
    selectManufacturer: bindActionCreators(userActions.selectManufacturer, dispatch),
    selectInspector: bindActionCreators(userActions.selectInspector, dispatch),
    updateManufacturer: bindActionCreators(userActions.updateManufacturer, dispatch),
    saveUrlToRedirect: bindActionCreators(userActions.saveUrlToRedirect, dispatch),
    clearUrlToRedirect: bindActionCreators(userActions.clearUrlToRedirect, dispatch),
    storeSelectedYear: bindActionCreators(userActions.storeSelectedYear, dispatch)
  });

  @withRouter
  @connect(mapStateToProps, mapDispatchToProps)
  class WithUser extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        user: {}
      };
    }

    static getDerivedStateFromProps({user, history, location, selectManufacturer, selectInspector, changeMenu, saveUrlToRedirect, clearUrlToRedirect, storeSelectedYear}) {
      return {
        user: new User(user, history, location, selectManufacturer, selectInspector, changeMenu, saveUrlToRedirect, clearUrlToRedirect, storeSelectedYear)
      };
    }

    render() {
      const {step, applicationId} = this.props.match.params;
      const passedProps = {
        signIn: this.props.signIn,
        logOut: this.props.logOut,
        changeMenu: this.props.changeMenu,
        updateManufacturer: this.props.updateManufacturer,
        saveUrlToRedirect: this.props.saveUrlToRedirect,
        clearUrlToRedirect: this.props.clearUrlToRedirect,
      };

      return <TargetComponent
        user={this.state.user}
        step={step}
        location={this.props.location}
        history={this.props.history}
        match={this.props.match}
        applicationId={applicationId}
        {...passedProps}
      />;
    }
  }

  return WithUser;
}

class User {
  //TODO remove and replace everywhere with call to constants/ROLES
  COMPONENT_MANUFACTURER = 'CMPNT_MNFCTR';
  BOAT_MANUFACTURER = 'BT_MNFCTR';
  TRAILER_MANUFACTURER = 'TRLR_MNFCTR';
  OIL_BRANDER = 'OIL_BRNDR';
  OIL_MANUFACTURER = 'OIL_FRMLTR';
  INTERNAL = 'INTERNAL_USER';
  INSPECTION = 'INSPEC';

  constructor(user, history, location, selectManufacturer, selectInspector, changeMenu, saveUrlToRedirect, clearUrlToRedirect, storeSelectedYear) {
    const setActiveRole = () => {
      const rolesOrder = [
        ROLES.BOAT_MANUFACTURER.serverName,
        ROLES.COMPONENT_MANUFACTURER.serverName,
        ROLES.TRAILER_MANUFACTURER.serverName,
        ROLES.OIL_MANUFACTURER.serverName,
        ROLES.OIL_BRANDER.serverName
      ];

      if (user.activeRole) return user.activeRole;
      if (this.isInternal() || this.isInspector()) return rolesOrder[0];

      for (let i = 0, l = rolesOrder.length; i < l; i++) {
        const role = this.roles.find(role => role === rolesOrder[i]);

        if (role) return role;
      }
    };

    this.id = user.id;
    this.token = user.token;
    this.roles = user.roles;
    const activeRoleServerName = setActiveRole();
    const newRoleKey = Object.keys(ROLES).find(roleKey => ROLES[roleKey].serverName === activeRoleServerName);
    this.activeRole = ROLES[newRoleKey];
    this.selectedManufacturer = user.selectedManufacturer;
    this.selectedInspector = user.selectedInspector;
    this.selectedYear = user.selectedYear;
    this.manufacturer = user.manufacturer;
    this.firstName = user.firstName;
    this.lastName = user.lastName;
    this.email = user.email;
    this.accountCode = user.accountCode;
    this.changeStoredMenuState = changeMenu;
    this.redirect = user.redirect;

    this.history = history;
    this.location = location;
    this.storeSelectManufacturer = selectManufacturer;
    this.storeSelectInspector = selectInspector;
    this.saveUrlToRedirect = saveUrlToRedirect;
    this.clearUrlToRedirect = clearUrlToRedirect;
    this.storeSelectedYear = storeSelectedYear;

    this.lastManufacturerCode = 0;
  }

  getAditionalMenu = () => {
    let ADDITIONAL_MENU = {};

    if (this.isInternal() && !this.selectedManufacturer) {
      ADDITIONAL_MENU = {
        [ROLES.COMPONENT_MANUFACTURER.readableName]: [
          {name: 'Manufacturers', link: this.getDashboardLink(ROLES.COMPONENT_MANUFACTURER.nameForUrl), index: 0},
          {name: 'Metrics', link: ROUTE.METRICS, index: 0},
        ],
        [ROLES.BOAT_MANUFACTURER.readableName]: [
          {name: 'Inspectors', link: ROUTE.INSPECTOR_DASHBOARD, index: 0},
          {name: 'Manufacturers', link: this.getDashboardLink(ROLES.BOAT_MANUFACTURER.nameForUrl), index: 0},
          {name: 'Metrics', link: ROUTE.METRICS, index: 0},
        ],
        [ROLES.TRAILER_MANUFACTURER.readableName]: [
          {name: 'Inspectors', link: ROUTE.INSPECTOR_DASHBOARD, index: 0},
          {name: 'Manufacturers', link: this.getDashboardLink(ROLES.TRAILER_MANUFACTURER.nameForUrl), index: 0},
          {name: 'Metrics', link: ROUTE.METRICS, index: 0},
        ],
        [ROLES.OIL_BRANDER.readableName]: [
          {name: 'Manufacturers', link: this.getDashboardLink(ROLES.OIL_BRANDER.nameForUrl), index: 0},
          {name: 'Metrics', link: ROUTE.METRICS, index: 0},
        ],
        [ROLES.OIL_MANUFACTURER.serverName]: [
          {name: 'Manufacturers', link: this.getDashboardLink(ROLES.OIL_MANUFACTURER.nameForUrl), index: 0},
          {name: 'Metrics', link: ROUTE.METRICS, index: 0},
        ]
      };
    } else if (!this.isInspector()) {
      ADDITIONAL_MENU = {
        [ROLES.COMPONENT_MANUFACTURER.readableName]: [
          {name: 'Summary', link: this.getSummaryLink(), index: 0},
          {name: 'Documents', link: this.getDocumentsLink(), index: 0},
          {name: 'REPORTS', link: this.getReportLink(), index: 0},
          {name: 'Component List', link: this.getListLink(), index: 0},
          {name: 'Family List', link: this.getFamiliesLink(), index: 0},
          {name: '+ New Component', link: this.getNewApplicationLink(), index: 1},
          {name: '+ New Component Family', link: this.getNewFamilyLink(), index: 1}
        ],
        [ROLES.BOAT_MANUFACTURER.readableName]: [
          {name: 'Summary', link: this.getSummaryLink(), index: 0},
          {name: 'Documents', link: this.getDocumentsLink(), index: 0},
          {name: 'REPORTS', link: this.getReportLink(), index: 0},
          {name: 'Inspection List', link: this.getInspectionsLink(), index: 2},
          {name: 'Boat Model List', link: this.getListLink(), index: 0},
          {name: '+ New boat model', link: this.getBoatApplicationLink(), index: 1}
        ],
        [ROLES.TRAILER_MANUFACTURER.readableName]: [
          {name: 'Summary', link: this.getSummaryLink(), index: 0},
          {name: 'Documents', link: this.getDocumentsLink(), index: 0},
          {name: 'REPORTS', link: this.getReportLink(), index: 0},
          {name: 'Inspection List', link: this.getInspectionsLink(), index: 0},
          {name: 'Trailer List', link: `/${this.getManufacturerCode()}/trailer`, index: 2},
          {name: '+ New Trailer', link: `/${this.getManufacturerCode()}/trailer#add`, index: 1}
        ],
        [ROLES.OIL_BRANDER.readableName]: [
          {name: 'Summary', link: this.getSummaryLink(), index: 0}
        ],
      };

      const userIsOilBrander = this.isOilBrander();
      const userIsOilManufacturer = this.isOilManufacturer();

      if (userIsOilBrander && userIsOilManufacturer) {
        ADDITIONAL_MENU[ROLES.OIL_BRANDER.readableName] = ADDITIONAL_MENU[ROLES.OIL_BRANDER.readableName].concat([
          {
            name: 'Formulation List',
            link: `/${this.getManufacturerCode()}/${ROLES.OIL_BRANDER.nameForUrl}/formula`,
            index: 0
          },
          {name: 'Brand List', link: `/${this.getManufacturerCode()}/${ROLES.OIL_BRANDER.nameForUrl}/brand`, index: 0},
          {
            name: '+ New Formulation',
            link: `/${this.getManufacturerCode()}/${ROLES.OIL_BRANDER.nameForUrl}/formula/new`,
            index: 1
          },
          {
            name: '+ New Brand',
            link: `/${this.getManufacturerCode()}/${ROLES.OIL_BRANDER.nameForUrl}/brand/new`,
            index: 1
          }
        ]);
      } else {
        if (userIsOilManufacturer) {
          ADDITIONAL_MENU[ROLES.OIL_MANUFACTURER.readableName] = ADDITIONAL_MENU[ROLES.OIL_BRANDER.readableName].concat([
            {
              name: 'Formulation List',
              link: `/${this.getManufacturerCode()}/${ROLES.OIL_BRANDER.nameForUrl}/formula`,
              index: 0
            },
            {
              name: '+ New Formulation',
              link: `/${this.getManufacturerCode()}/${ROLES.OIL_BRANDER.nameForUrl}/formula/new`,
              index: 1
            }
          ]);
        }
        if (userIsOilBrander) {
          ADDITIONAL_MENU[ROLES.OIL_BRANDER.readableName] = ADDITIONAL_MENU[ROLES.OIL_BRANDER.readableName].concat([
            {
              name: 'Brand List',
              link: `/${this.getManufacturerCode()}/${ROLES.OIL_BRANDER.nameForUrl}/brand`,
              index: 0
            },
            {
              name: '+ New Brand',
              link: `/${this.getManufacturerCode()}/${ROLES.OIL_BRANDER.nameForUrl}/brand/new`,
              index: 1
            }
          ]);
        }
      }

      if (this.isInternal()) {
        ADDITIONAL_MENU[ROLES.BOAT_MANUFACTURER.readableName].push({
          name: '+ New Inspection',
          link: this.getNewInspectionsLink(),
          index: 1
        });
        ADDITIONAL_MENU[ROLES.TRAILER_MANUFACTURER.readableName].push({
          name: '+ New Inspection',
          link: this.getNewInspectionsLink(),
          index: 1
        });
      }
    } else {
      ADDITIONAL_MENU = {
        [ROLES.BOAT_MANUFACTURER.readableName]: [
          {name: 'Summary', link: this.getSummaryLink(), index: 0},
          {name: 'Documents', link: this.getDocumentsLink(), index: 0},
          {name: 'REPORTS', link: this.getReportLink(), index: 0},
          {name: 'Inspection List', link: this.getInspectionsLink(), index: 2},
          {name: 'Boat Model List', link: this.getListLink(), index: 0},
          {name: '+ New Inspection', link: this.getNewInspectionsLink(), index: 1}
        ],
        [ROLES.TRAILER_MANUFACTURER.readableName]: [
          {name: 'Summary', link: this.getSummaryLink(), index: 0},
          {name: 'Documents', link: this.getDocumentsLink(), index: 0},
          {name: 'REPORTS', link: this.getReportLink(), index: 0},
          {name: 'Inspection List', link: this.getInspectionsLink(), index: 0},
          {name: 'Trailer List', link: `/${this.getManufacturerCode()}/trailer`, index: 2},
          {name: '+ New Inspection', link: this.getNewInspectionsLink(), index: 1}
        ],
      };
    }

    return ADDITIONAL_MENU;
  };

  isOilBrander = () => {
    let rolesList = [];

    if (this.selectedManufacturer) {
      rolesList = this.selectedManufacturer.allRoles.split(',').map(roleString => roleString.trim());
    } else if (this.manufacturer) {
      rolesList = this.manufacturer.roles;
    }

    if(!rolesList)
      rolesList = [];
    const availableForThisUserRoles = rolesList.filter(role =>
      (this.roles.indexOf(role) !== -1 || this.roles[0] === ROLES.INTERNAL.serverName)
    );
    return availableForThisUserRoles.indexOf(ROLES.OIL_BRANDER.serverName) !== -1;
  };

  isOilManufacturer = () => {
    let rolesList = [];

    if (this.selectedManufacturer) {
      rolesList = this.selectedManufacturer.allRoles.split(',').map(roleString => roleString.trim());
    } else if (this.manufacturer) {
      rolesList = this.manufacturer.roles;
    }

    if(!rolesList)
      rolesList = [];
    const availableForThisUserRoles = rolesList.filter(role =>
      (this.roles.indexOf(role) !== -1 || this.roles[0] === ROLES.INTERNAL.serverName)
    );
    return availableForThisUserRoles.indexOf(ROLES.OIL_MANUFACTURER.serverName) !== -1;
  };

  isInternal = () => {
    return this.roles[0] === this.INTERNAL;
  };

  isInspector = () => {
    return this.roles[0] === this.INSPECTION;
  };

  isManufacturerSelected = () => {
    return !!this.selectedManufacturer;
  };

  changeMenu = userRole => {
    const newRoleKey = Object.keys(ROLES).find(roleKey => ROLES[roleKey].serverName === userRole);
    this.activeRole = ROLES[newRoleKey];
    this.changeStoredMenuState(userRole);

    this.clearListState();

    //setTimeout(() => {window.sessionStorage.clear();}, 0);
  };

  setActiveRole = userRole => {
    const newRoleKey = Object.keys(ROLES).find(roleKey => ROLES[roleKey].serverName === userRole);
    this.activeRole = ROLES[newRoleKey];
    this.changeStoredMenuState(userRole);
  };

  getManufacturerName = () => {
    return this.selectedManufacturer ? this.selectedManufacturer.name : (this.isInternal() || this.isInspector()) ? '' : this.manufacturer.name;
  };

  getManufacturerCode = () => {
    return this.selectedManufacturer ? this.selectedManufacturer.code : (this.isInternal() || this.isInspector()) ? 0 : this.manufacturer.code;
  };

  getManufacturerStatus = () => {
    return this.selectedManufacturer ? this.selectedManufacturer.active : false;
  };

  getInspectorName = () => {
    return this.selectedInspector ? this.selectedInspector.name : '';
  };

  getInspectorCode = () => {
    return this.selectedInspector ? this.selectedInspector.code : '';
  };

  getActiveRole = () => {
    return this.activeRole.serverName;
  };

  isMultipleRoles = () => {
    return this.roles.length > 1 || this.isInternal() || this.isInspector();
  };

  getRoleNameForURL = () => {
    return this.activeRole.nameForUrl;
  };

  getRoleListSceneUrlPostfix = () => {
    return this.activeRole.listSceneUrlPostfix;
  };

  getRoleName = roleServerName => {
    if (!roleServerName) return this.activeRole.readableName;
    const roleKey = Object.keys(ROLES).find(roleKey => ROLES[roleKey].serverName === roleServerName);
    return ROLES[roleKey].readableName;
  };

  goTo = link => {
    this.history.push(link);
  };

  replaceLocation = link => {
    this.history.replace(link);
  };

  goToUserStartPage = (code) => {
    if (!code) this.goToDashboard();
    else if (this.isInspector()) this.goToList(code);
    else this.goToSummary(code);
  };

  goToLogin = () => {
    this.history.push(ROUTE.LOGIN);
  };

  goToDashboard = role => {
    this.history.push(this.getDashboardLink(role));
  };

  goToInspectorDashboard = () => {
    this.history.push(ROUTE.INSPECTOR_DASHBOARD);
  };

  goToSummary = (code, role) => {
    const url = `/${code || this.getManufacturerCode()}/${role || this.activeRole.nameForUrl}/summary`;
    this.history.push(url);
  };

  goToList = (manufacturerCode, params) => {
    let url = this.getListLink(manufacturerCode);
    if (params) {
      let searchString = qs.stringify(params, {addQueryPrefix: true});
      this.history.replace(url + searchString);
    } else {
      this.history.push(url);
    }
  };

  goToInspectionList = params => {
    let url = this.getInspectionsLink();

    if (params) {
      let searchString = qs.stringify(params, {addQueryPrefix: true});
      this.history.replace(url + searchString);
    } else {
      this.history.push(url);
    }
  };

  goToInspectionDetails = id => {
    this.history.push(`${this.getInspectionsLink()}/${id}/details`);
  };

  goToInspectionEdit = id => {
    this.history.push(`${this.getInspectionsLink()}/${id}/edit`);
  };

  goToFamilyList = params => {
    let url = this.getFamiliesLink();

    if (params) {
      let searchString = qs.stringify(params, {addQueryPrefix: true});
      this.history.replace(url + searchString);
    } else {
      this.history.push(url);
    }
  };

  goToFamilyDetails = id => {
    this.history.push(`${this.getFamiliesLink()}/${id}/details`);
  };

  goToFamilyEdit = id => {
    this.history.push(`${this.getFamiliesLink()}/${id}/edit`);
  };

  goToReport = (manufacturerCode) => {
    const url = `/${manufacturerCode || this.getManufacturerCode()}/${this.getRoleNameForURL()}/report`;
    this.history.push(url);
  };

  goToApplication = () => {
    const url = `/${this.getManufacturerCode()}/${this.getRoleNameForURL()}/application`;
    this.history.push(url);
  };

  goToApplicationStep = (id, step, options) => {
    options = options || {};
    const url = `/${this.getManufacturerCode()}/${this.getRoleNameForURL()}/application/${id}/${step}`;
    this.history[options.replace ? 'replace' : 'push'](url);
  };

  goToApplicationDetails = (id) => {
    const url = `/${this.getManufacturerCode()}/${this.getRoleNameForURL()}/application/${id}`;
    this.history.push(url);
  };

  getSummaryLink = () => {
    return `/${this.getManufacturerCode()}/${this.activeRole.nameForUrl}/summary`;
  };

  getDocumentsLink = params => {
    let url = `/${this.getManufacturerCode()}/${this.activeRole.nameForUrl}/documents`;

    if (params) {
      let searchString = qs.stringify(params, {addQueryPrefix: true});
      return url + searchString;
    } else {
      return url;
    }
  };

  getDashboardLink = role => {
    return `/${role || this.activeRole.nameForUrl}/dashboard`;
  };

  getNewInspectionsLink = () => {
    return `/${this.getManufacturerCode()}/${this.activeRole.nameForUrl}/inspection/new`;
  };

  getInspectionsLink = () => {
    return `/${this.getManufacturerCode()}/${this.activeRole.nameForUrl}/inspection`;
  };

  getFamiliesLink = () => {
    return `/${this.getManufacturerCode()}/${this.activeRole.nameForUrl}/family`;
  };

  getListLink = manufacturerCode => {
    return `/${manufacturerCode || this.getManufacturerCode()}/${this.getRoleNameForURL()}${this.getRoleListSceneUrlPostfix()}`;
  };

  getReportLink = manufacturerCode => {
    return `/${this.getManufacturerCode()}/${manufacturerCode || this.getRoleNameForURL()}/report`;
  };

  getNewApplicationLink = () => {
    return `/${this.getManufacturerCode()}/${this.getRoleNameForURL()}/application/new`;
  };

  getBoatApplicationLink = () => {
    return `/${this.getManufacturerCode()}/${this.getRoleNameForURL()}/application/new/InitNewBoat`;
  };

  getNewFamilyLink = () => {
    return `${this.getFamiliesLink()}/new`;
  };

  goBack = () => {
    this.history.goBack();
  };

  selectManufacturer = (manufacturer, withoutRedirect) => {
    this.clearListState();

    this.storeSelectManufacturer(manufacturer);
    if (manufacturer && !withoutRedirect) {
      this.goToUserStartPage(manufacturer.code);
    }
  };

  selectInspector = inspector => () => {
    this.clearListState();

    this.storeSelectInspector(inspector);
    if (inspector ) {
      this.goToDashboard();
    } else {
      this.goToInspectorDashboard();
    }
  };

  clearListState = () => {
    window.sessionStorage.removeItem('listState');
    window.sessionStorage.removeItem('brandListState');
    window.sessionStorage.removeItem('formulaListState');
    window.sessionStorage.removeItem('boatListState');
    window.sessionStorage.removeItem('inspectionListState');
    window.sessionStorage.removeItem('documentsListState');
    //this.updateURLSearchString({});
  };

  saveState = (key, state, excludedFields = []) => {
    let stateToSave = {...state};
    excludedFields.forEach(fieldName => {
      delete stateToSave[fieldName];
    });
    window.sessionStorage.setItem(key, JSON.stringify(stateToSave));
  };

  getStoredState = (key, defaultState = {}) => {
    const stateFromURLSearchString = qs.parse(this.location.search, {ignoreQueryPrefix: true});
    const stateFromSessionStorage = JSON.parse(window.sessionStorage.getItem(key));

    const parseStrings = stateToParse => {
      let parsedState = {};

      for (const field in stateToParse) {
        if (stateToParse[field] === 'false' || stateToParse[field] === 'true') {
          parsedState[field] = stateToParse[field] !== 'false';
        } else if (isFinite(stateToParse[field])) {
          parsedState[field] = +stateToParse[field];
        } else if (typeof stateToParse[field] === 'object' && !stateToParse[field].length) {
          parsedState[field] = parseStrings(stateToParse[field]);
        } else {
          parsedState[field] = stateToParse[field];
        }
      }
      return parsedState;
    };

    const removeDefaultValuesFromNewState = (defaultState, stateToClear) => {
      for (const param in stateToClear) {
        if (stateToClear[param] === defaultState[param]) {
          delete stateToClear[param];
        } else {
          if (typeof stateToClear[param] === 'object' && Object.keys(stateToClear[param]).length === 0) {
            delete stateToClear[param];
          }
        }
      }
      return stateToClear;
    };

    const removeValuesSetAsDefaultInURL = (stateFromURLSearchString, stateToClear) => {
      for (const param in stateToClear) {
        if (stateFromURLSearchString[param] === 'default') delete stateToClear[param];
      }
      return stateToClear;
    };

    let storedState = {...stateFromSessionStorage, ...parseStrings(stateFromURLSearchString)};
    removeValuesSetAsDefaultInURL(stateFromURLSearchString, storedState);
    removeDefaultValuesFromNewState(defaultState, storedState);
    return storedState;
  };

  updateURLSearchString = paramsObj => {
    const urlParams = qs.parse(this.location.search, {ignoreQueryPrefix: true});

    let newUrlParams = {...urlParams, ...paramsObj};
    for (const param in newUrlParams) {
      if (newUrlParams[param] === 'default' || newUrlParams[param] === '') delete newUrlParams[param];
    }

    let searchString = qs.stringify(newUrlParams, {addQueryPrefix: true});
    this.history.replace(this.location.pathname + searchString + this.location.hash);
  };

  saveSelectedYear = year => {
    const role = this.getRoleNameForURL();

    this.storeSelectedYear(role, year);
  };

  getSelectedYear = () => {
    const role = this.getRoleNameForURL();

    return(this.selectedYear ? this.selectedYear[role] : '')
  }
}



// WEBPACK FOOTER //
// ./src/app/HOC/User.jsx